import type { FC } from "react";

import { Dropdown, IconButton, Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { EllipsisDropdownItemStyled } from "app/pages/digital-marketing/generative-ai/llm-tracker/homepage/styledComponents";
import type {
    DropdownOnClickProps,
    IAiTrackerTableRow,
} from "app/pages/digital-marketing/generative-ai/llm-tracker/homepage/types";
import { getMenuItems } from "app/pages/digital-marketing/generative-ai/llm-tracker/menu/consts";

interface ITableRowDropdownProps {
    row: IAiTrackerTableRow;
    onClick: (props: DropdownOnClickProps, row: IAiTrackerTableRow) => void;
    isSubscribePending?: boolean;
}

export const TableRowDropdown: FC<ITableRowDropdownProps> = ({ row, onClick, isSubscribePending }) => {
    const menuItems = getMenuItems({
        canEdit: row.canEdit,
        canDelete: row.canDelete,
        campaign: row,
        isSubscribePending,
    });

    return (
        <Dropdown
            appendTo="#ai-tracker-table"
            width="auto"
            onClick={(props: DropdownOnClickProps) => onClick?.(props, row)}
        >
            {[
                <Tooltip
                    className="PlainTooltip-element plainTooltip-more-action-monitor-keyword-groups"
                    content={translate("global.moreActions")}
                >
                    <span>
                        <IconButton
                            id={`moreActions-${row.id}`}
                            iconName="dots-more"
                            type="flat"
                            iconSize="20px"
                            height="34px"
                            width="34px"
                        />
                    </span>
                </Tooltip>,
                ...Object.entries(menuItems).map(([key, item]) => (
                    <EllipsisDropdownItemStyled
                        key={key}
                        id={key}
                        iconName={item.icon}
                        disabled={!item.isEnabled}
                    >
                        {item.text}
                    </EllipsisDropdownItemStyled>
                )),
            ]}
        </Dropdown>
    );
};
